import React, { useState } from "react";
import StarRating from "./StarRating";
import { reviewProduct } from "../redux/features/productSlice";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getToken, isProductReviewed } from "../resources/helper/helper";
import { CircularProgress } from "@mui/material";

const ReviewForm = ({ productId }) => {
  const dispatch = useDispatch();
  const { orders } = useSelector((state) => state.order);
  const { reviewLoading } = useSelector((state) => state.product);
  const token = getToken();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = isProductReviewed(orders, productId);
    if (data && token) {
      const payload = {
        token,
        productId: data?.productId,
        data: { stars: rating, comment, orderId: data?.orderId, pvt: false },
      };

      dispatch(reviewProduct(payload))
        .unwrap()
        .then(() => {
          toast.success("Review Added Successfully!!", {
            position: "top-center",
            theme: "colored",
          });
          clearState();
        })
        .catch((err) => {
          toast.error(err, {
            position: "top-center",
            theme: "colored",
          });
        });
    } else {
      toast.error("To leave a review, please purchase the product first.", {
        position: "top-center",
        theme: "colored",
      });
    }
  };

  const clearState = () => {
    setRating(0);
    setComment("");
  };

  return (
    <div className="comment-form">
      <h4 className="mb-15">Add a review</h4>
      <StarRating setRating={setRating} rating={rating} />
      <div className="row">
        <div className="col-lg-8 col-md-12">
          <form
            className="form-contact comment_form"
            id="commentForm"
            onSubmit={handleSubmit}
          >
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <textarea
                    className="form-control w-100"
                    name="comment"
                    id="comment"
                    cols={30}
                    rows={9}
                    placeholder="Write Comment"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <button
                type="submit"
                className="button button-contactForm"
                style={{ width: 300 }}
              >
                {reviewLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Submit Review"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ReviewForm;
